'use client';
import { styled } from '@linaria/react';
import { useIsInteractingObserver } from '@fe-common-utils/libs/hooks/useIsInteractingObserver';
import { CustomEventName, GTMEventKey, sendGTM, GTMConstants } from '@fe-cnyes/fe-common-gtm';
import { useCallback, useRef } from 'react';

const GTM_EVENT_IMP_PLACEMENT = {
  [GTMEventKey.EVENT_NAME]: CustomEventName.IMP_PLACEMENT,
  [GTMEventKey.SECTION]: `${GTMConstants.SECTION_PLACEHOLDER}_文末`
};

const OBSERVER_OPTIONS = {
  root: null,
  rootMargin: '0px',
  threshold: 0.1
};

const DOWNLOAD_APP_LINK =
  'http://www.cnyes.com/app/?utm_source=mweb&utm_medium=HamMenuBanner&utm_campaign=fixed&utm_content=entr';

const ListItem = styled.li`
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0.5px;
  position: relative;

  &::before {
    content: '';
    background-image: url('/assets/icons/arrows/red-arrow.svg');
    height: 20px;
    width: 20px;
    display: inline-block;
    margin-right: 4px;
    vertical-align: middle;
    margin-bottom: 4px;
  }

  a {
    color: #e03f19;
    margin-left: 16px;
    text-decoration: underline;
  }
`;

/**
 * 此層元件因 NewsContent 不適合傳送 imp placement，
 * 獨立拔出來做文末廣告事件 GTM 事件
*/

export const DownloadAppLink = () => {
  const countArticleCompletion = useRef(0);
  const onLeaveArticle = useCallback(() => {
    if (!countArticleCompletion.current) {
      countArticleCompletion.current = 1;
      sendGTM(GTM_EVENT_IMP_PLACEMENT);
    }
  }, []);
  const newsContentReference = useIsInteractingObserver(onLeaveArticle, OBSERVER_OPTIONS);
  return (
    <ListItem key="download-app" ref={newsContentReference}>
      掌握全球財經資訊<a href={DOWNLOAD_APP_LINK}>點我下載APP</a>
    </ListItem>
  )
};
